module.exports = __webpack_public_path__ + "static/media/index.23bde7dc.less";